import { makeAutoObservable } from 'mobx'
import { REPORT } from 'service/api/ReportApi'
import * as API from 'service/api/ReportApi'
import table from '../common/table'
import { IInit } from 'models/Global.model'

class ReportStore {
  constructor() {
    makeAutoObservable(this)
  }

  myReportTable = new table(API.GET_MY_REPORT_PAGE_LIST)

  init = (data: IInit) => {
    const {
      param = {},
      pageSize = 10,
      pageNo = 1,
      isPageNum = true,
      isResetParam = false
    } = data

    this.myReportTable.init(param, isPageNum, isResetParam)
    this.myReportTable.getList(pageNo, pageSize)
  }

  reportTable = new table(API.GET_REPORT_LIST)

  initReportTable = (data: IInit) => {
    const {
      param = {},
      pageSize = 10,
      pageNo = 1,
      isPageNum = true,
      isResetParam = false
    } = data

    this.reportTable.init(param, isPageNum, isResetParam)
    this.reportTable.getList(pageNo, pageSize)
  }

  report = async (data: any) => {
    return await REPORT(data)
  }

  exportMyReportList = async (data: any) => {
    return await API.EXPORT_MY_REPORT_LIST(data)
  }

  exportReportList = async (data: any) => {
    return await API.EXPORT_REPORT_LIST(data)
  }

  updateReport = async (data: any) => {
    return await API.UPDATE_REPORT(data)
  }

  dealReport = async (reportId: string) => {
    return await API.DEAL_REPORT(reportId)
  }
}

export default new ReportStore()
